/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsFloppyCrossOut: {
  name: 'floppy-cross-out';
  data: string;
} = {
  name: 'floppy-cross-out',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="m4.707 20.707 16-16a1 1 0 0 0-1.414-1.414l-16 16a1 1 0 1 0 1.414 1.414ZM5 3a2 2 0 0 0-2 2v10a1 1 0 1 0 2 0V5h3v4a1 1 0 0 0 2 0V5h4a1 1 0 1 0 0-2H5Zm16 16v-9a1 1 0 1 0-2 0v9h-3v-2a2 2 0 0 0-2-2h-1a1 1 0 1 0 0 2h1v2H9a1 1 0 1 0 0 2h10a2 2 0 0 0 2-2Z" fill="currentColor"/></svg>`,
};
